import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';
import { isEmpty } from '../../core/util/empty';
import { withStyles } from '@material-ui/core/styles';
import { biggerThanOrEqualTo } from '../../core/util/styledComponents';

const styles = theme => ({
  tabsIndicator: {
    backgroundColor: colors.crunchBerry,
    height: '3px',
    padding: '0',
    minHeight: 'unset',
  },
  tabRoot: {
    textTransform: 'none',
    textAlign: 'center',
    fontFamily: fontFamily.book,
    color: `${colors.squid}!important`,
    fontSize: fontSize.default,
    transition: 'opacity 200ms ease',
    lineHeight: '20px',
    '-webkit-font-smoothing': 'antialiased',
    '&:hover': {
      color: colors.squid,
      opacity: 1,
    },
  },
});

const Root = styled.div`
  flex-grow: 1;
  background-color: ${colors.whiteGrey};
`;
const OwnStyledTabs = styled(Tabs)`
  ${biggerThanOrEqualTo.lg`
    div {
      height: 128px;
    }
  `}
`;

const TabContent = styled.div`
  font-family: ${fontFamily.book};
  -webkit-font-smoothing: antialiased;
`;

class CustomizedTabs extends Component {
  state = {
    value: false,
  };

  handleChange = (event, value, tabs) => {
    this.setState({ value });
    tabs[value].onClick();
  };

  render() {
    const { value } = this.state;
    const { className, tabs, selectedTabIndex, classes, isCentered, styledTabs } = this.props;
    const StyledTabs = styledTabs || OwnStyledTabs;
    return (
      <Root className={className}>
        <StyledTabs
          value={value !== false ? value : selectedTabIndex}
          onChange={(event, value) => this.handleChange(event, value, tabs)}
          classes={{ indicator: classes.tabsIndicator }}
          centered={isCentered}
        >
          {this.props.tabs.map(tab => (
            <Tab
              key={tab.label}
              disableRipple
              label={tab.label}
              content={null}
              classes={{ root: classes.tabRoot }}
            />
          ))}
        </StyledTabs>
        {!isEmpty(this.props.content) && <TabContent>{this.props.content}</TabContent>}
      </Root>
    );
  }
}

CustomizedTabs.propTypes = {
  content: PropTypes.object,
  tabs: PropTypes.array,
  className: PropTypes.string,
  selectedTabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  classes: PropTypes.object,
  isCentered: PropTypes.bool,
  styledTabs: PropTypes.any,
  tabsIndicator: PropTypes.object,
};

CustomizedTabs.defaultProps = {
  isCentered: false,
};

export default withStyles(styles)(CustomizedTabs);
